import React, {memo, useImperativeHandle} from 'react';
import WebView from 'react-native-webview';
import useWebviewBack from '../../hooks/useWebviewBack';
import useWebviewJSEventBus from '../../hooks/useWebviewJSEventBus';
import WebviewJSBridge, {middlewareType} from '../../utils/webviewJSBridge';
import {useCheckToken} from '../../request/token';
import {useEventEmit} from '../../hooks/useEventEmit';

export type Props = {
  style?: any;
  url: string;
  skipToken?: boolean;
  enableBack?: boolean;
  noRandom?: boolean;
  eventHandle?: middlewareType;
  onLoadEnd?: () => void;
};

export type WebviewCustomerRef = {
  sendMessage: typeof WebviewJSBridge.prototype.request;
};

const WebviewCustomer = React.forwardRef<WebviewCustomerRef, Props>(
  (props, ref): React.JSX.Element => {
    const loadend = React.useRef(false);
    // 接受来自webview的事件，主要是保存用户的年纪选择
    const {onWebMessage, webviewRef, jSBridge, injectJavaScriptText} =
      useWebviewJSEventBus();
    const {webviewRef: webviewRef2, onNavigationStateChange} = useWebviewBack();
    const {token} = useCheckToken(!props.skipToken);
    const eventEmit = useEventEmit();
    jSBridge.addMiddleware((eventName, data, res) => {
      switch (eventName) {
        case 'onloadend': {
          onWebViewLoadEnd();
          break;
        }
      }
    });
    if (props.eventHandle) {
      jSBridge.addMiddleware(props.eventHandle);
    }
    useImperativeHandle(ref, () => ({
      sendMessage: config => {
        return new Promise<unknown>((resolve, reject) => {
          if (webviewRef.current && loadend.current) {
            jSBridge
              .request(config)
              .then(res => {
                resolve(res);
              })
              .catch(e => {
                reject(e);
              });
          } else {
            eventEmit.once('webviewLoadEnd', () => {
              jSBridge
                .request(config)
                .then(res => {
                  resolve(res);
                })
                .catch(e => {
                  reject(e);
                });
            });
          }
        });
      },
    }));
    const onWebViewLoadEnd = () => {
      loadend.current = true;
      eventEmit.emit('webviewLoadEnd');
      props.onLoadEnd && props.onLoadEnd();
    };
    console.log('url', props.url);
    const url = new URL(props.url);
    if (!props.noRandom) {
      url.searchParams.append('r', String(Math.random()));
    }
    url.searchParams.append('token', token);
    console.log(url);
    return (
      <>
        {props.skipToken || token ? (
          <WebView
            style={props.style}
            ref={node => {
              webviewRef.current = node;
              webviewRef2.current = node;
            }}
            onNavigationStateChange={
              props.enableBack ? onNavigationStateChange : () => null
            }
            mixedContentMode={'always'}
            javaScriptEnabled
            bounces={false}
            onMessage={onWebMessage}
            injectedJavaScript={injectJavaScriptText}
            source={{uri: url.href}}
            onLoadEnd={onWebViewLoadEnd}
            allow={'microphone *'}
          />
        ) : null}
      </>
    );
  },
);

export const WebviewCustomerMemo = memo(
  WebviewCustomer,
  (oldProps, newProps) => {
    return oldProps.url === newProps.url;
  },
);

export default WebviewCustomer;
